// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.admin',
    path: 'P0101ArticleSns/index',
    name: 'TTC PRESS SNS Schedule',
    component: () => import('./PgMainPage'),
    meta: {
      roles: ['SA', 'PA', 'VA', 'PAP', 'PAL', 'PAC', 'PAA']
    }
  }
]
